import { Component, HostListener, Input } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { CustomerCreateModel } from '../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    standalone: false
})
export class ModalComponent {
  isModalOpen = this.modalService.modalState$;

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.closeModal();
  }
  
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeModal();
  }
}
